<div class="custom-container">
    <div class="row justify-content-center text-center" *ngIf="!isLoading && emailVerified">
        <div class="col-md-8">
            <br><br>
            <h2 style="color: #0fad00;">Email Verification Successful</h2>
            <p style="font-size: 20px; color: #5C5C5C;">
                Your email has been successfully verified. You may now close this page and proceed to the next step of
                registration. This page will automatically close in <strong>{{ countdown }}</strong> seconds.
            </p>
            <a href="javascript:void(0);" (click)="closeWindow()" class="btn btn-success">
                Close Now
            </a>
            <br><br>
        </div>
    </div>
    <div class="row justify-content-center text-center" *ngIf="!isLoading && emailNotVerified">
        <div class="col-md-8">
            <br><br>
            <h2 style="color: #cc0000;">Email Verification Unsuccessful</h2>
            <p style="font-size: 20px; color: #5C5C5C;">
                Unfortunately, we were unable to verify your email. Please try again or contact support if the issue
                persists. This page will automatically close in <strong>{{ countdown }}</strong> seconds.
            </p>
            <a href="javascript:void(0);" (click)="closeWindow()" class="btn btn-success">
                Close Now
            </a>
            <br><br>
        </div>
    </div>
    <div class="row justify-content-center text-center" *ngIf="isLoading">
        <div class="loading-container">
            <p style="font-size: 20px; color: #5C5C5C;">
                Verifying Please Wait...
            </p>
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>